import { useSuspenseQuery } from '@tanstack/react-query';
import type { ReactElement } from 'react';
import { meQuery } from '../api';
import { Signpost } from '../ui';

/**
 * "Ask the data" from an Executive's own pages (APP-191 D11, Task 3.10): Home's Executive panel
 * and Budget pools. For Executives only: the Stock Admin team and Sector Leads reach Ask the data
 * from Insights, as before. It opens a new conversation.
 */
export function AskDataEntry({ about }: { about: string }): ReactElement | null {
  const { data: me } = useSuspenseQuery(meQuery);
  if (!me.roles.some((r) => r.role === 'executive')) return null;
  return (
    <Signpost
      title="Ask the data"
      icon="sparkle"
      action={{ label: 'Ask the data', href: '/insights/ask' }}
    >
      {about}
    </Signpost>
  );
}
